import { defineWave } from '../schema';

/** BLOC G2 — LE RAPPEL DU MONDE 3. Quatorze secondes pour ne pas finir sur du vide.
 *
 *  Même fonction que `d3-rappel` au monde 2, avec le vocabulaire du monde 3 :
 *  une Égide qu'il faut contourner et une salve de Dards qui interdit de le
 *  faire tranquillement. Rien de neuf — le rôle d'un rappel est d'occuper, pas
 *  d'enseigner.
 *
 *  ⚠️ Dernier spawn à 6 s pour 14 s de durée. Ces huit secondes de queue
 *  laissent aux traînards le temps de mourir ou de sortir AVANT le bloc de
 *  boss. Le silence de six secondes qui ouvre `boss-colosse` ne garantit
 *  qu'une chose — qu'aucun ennemi n'APPARAÎT. Que l'écran soit effectivement
 *  vide se joue ici. */
export default defineWave({
  id: 'g2-rappel',
  duration: 14,
  spawns: [
    { at: 0.5, enemy: 'egide', lane: 3, count: 1, spacing: 0 },
    { at: 2.5, enemy: 'dard', lane: 2, count: 3, spacing: 0.45 },
    { at: 2.9, enemy: 'dard', lane: 4, count: 3, spacing: 0.45 },
    { at: 6.0, enemy: 'mite', lane: 3, count: 9, spacing: 0.07 },
  ],
});
